import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule, MaterialModule, TranslateModule, TablerIconsModule],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {

  sessionStarted: boolean = false;

  constructor(private router: Router, private authService: AuthService) {





  }

  ngOnInit(): void {
     //Adapt the breadcrumb information depending on the user role
    if (this.authService.sessionToken != "") {
      this.sessionStarted = true;
    }else {
      this.sessionStarted = false;
    }
  }

 ngAfterViewInit(): void {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }


}
